import { render, staticRenderFns } from "./mobile-notification-controls.vue?vue&type=template&id=a597a216&scoped=true"
import script from "./mobile-notification-controls.vue?vue&type=script&lang=js"
export * from "./mobile-notification-controls.vue?vue&type=script&lang=js"
import style0 from "./mobile-notification-controls.vue?vue&type=style&index=0&id=a597a216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a597a216",
  null
  
)

export default component.exports